import styled from 'styled-components';
import React, { memo } from 'react';

const Text = styled.text`
  font-size: 9px;
  fill: #17181a;
`;

type Props = {
  value: number;
};

const SvgCabinLuggage = ({ value, ...rest }: Props) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <rect x={3.5} y={8.5} width={17} height={13} rx={1.5} stroke="#17181A" />
    <path d="M17 9c0-2.21-2.239-4-5-4S7 6.79 7 9" stroke="#17181A" />
    <Text dx="8" dy="19">
      {value}
    </Text>
  </svg>
);

const Memo = memo(SvgCabinLuggage);
export default Memo;
